// /src/components/modals/ImovelEditorModal/EditorHeader.jsx
import React from 'react';
import { FiX, FiShield, FiStar } from 'react-icons/fi';

export const EditorHeader = ({ formData, onClose }) => (
    <header className="px-10 py-8 border-b border-[var(--border-color)] flex justify-between items-center bg-[var(--bg-card)]">
        <div className="flex items-center gap-6">
            <div className="w-16 h-16 rounded-2xl border border-[var(--border-color)] flex items-center justify-center text-accent bg-[var(--bg-main)]">
                <FiShield size={28} />
            </div>
            <div>
                <h2 className="text-2xl font-black uppercase tracking-tighter text-auto leading-none">
                    Editor de Plano <span className="text-accent">TIM</span>
                </h2>
                <div className="flex items-center gap-4 mt-2">
                    <span className="text-[9px] font-black uppercase tracking-widest text-sec-auto">
                        REF: {formData?.codigoImovel}
                    </span>
                    {formData?.isDestaque && (
                        <div className="flex items-center gap-2 px-3 py-0.5 rounded-lg border border-amber-500/20 bg-amber-500/10">
                            <FiStar size={10} className="text-amber-500 fill-amber-500" />
                            <span className="text-[9px] font-black uppercase text-amber-500">
                                {formData?.seloDestaque?.replace(/_/g, ' ') || 'Plano de Elite'}
                            </span>
                        </div>
                    )}
                </div>
            </div>
        </div>
        <button onClick={onClose} className="p-3 rounded-full hover:bg-red-500/10 hover:text-red-500 transition-all">
            <FiX size={28} />
        </button>
    </header>
);